import type { ConditionEvaluator } from "../types/conditionEvaluators.ts";
import type { INumberBinaryCondition, INumberTernaryCondition, NumberCondition } from "../types/conditions/number.ts";
import { Operator } from "../types/operators.ts";
import { createThrowConditionNotImplementedForEvaluator, getSingleValue } from "./common.ts";

const throwNotImplemented = createThrowConditionNotImplementedForEvaluator("number");

const binaryConditionEvaluator: ConditionEvaluator<INumberBinaryCondition> = (condition, resolve) => {
  const subject = getSingleValue("number", condition.subject, resolve);
  const object = getSingleValue("number", condition.object, resolve);

  switch (condition.operator) {
    case Operator.EQ:
      return subject === object;

    case Operator.NE:
      return subject !== object;

    case Operator.GT:
      return subject > object;

    case Operator.GTE:
      return subject >= object;

    case Operator.LT:
      return subject < object;

    case Operator.LTE:
      return subject <= object;

    default:
      return throwNotImplemented(condition);
  }
};

const ternaryConditionEvaluator: ConditionEvaluator<INumberTernaryCondition> = (condition, resolve) => {
  const subject = getSingleValue("number", condition.subject, resolve);
  const left = getSingleValue("number", condition.left, resolve);
  const right = getSingleValue("number", condition.right, resolve);

  switch (condition.operator) {
    case Operator.Between:
    case Operator.NotBetween: {
      const isBetween = subject >= left && subject <= right;

      return condition.operator === Operator.Between ? isBetween : !isBetween;
    }

    default:
      return throwNotImplemented(condition);
  }
};

export const conditionEvaluator: ConditionEvaluator<NumberCondition> = (condition, resolve): boolean => {
  switch (condition.operator) {
    case Operator.EQ:
    case Operator.NE:
    case Operator.GT:
    case Operator.GTE:
    case Operator.LT:
    case Operator.LTE:
      return binaryConditionEvaluator(condition, resolve);

    case Operator.Between:
    case Operator.NotBetween: {
      return ternaryConditionEvaluator(condition, resolve);
    }

    default:
      return throwNotImplemented(condition);
  }
};

export default conditionEvaluator;
